define('home/collections/SettingsBlockListCollection',[
    'core/api',
    'core/collections/PaginatedCollection',
    'core/UniqueModel',

    'home/models/User',
], function (
    api,
    PaginatedCollection,
    UniqueModel,

    User
) {
    'use strict';

    var SettingsBlockListCollection = PaginatedCollection.extend({
        PER_PAGE: 10,

        url: api.getURL('users/block/list.json'),
        model: UniqueModel.boundModel(User),
    });

    return SettingsBlockListCollection;
});

